// extracted by mini-css-extract-plugin
module.exports = {"SSimilarStreamingTitles":"SimilarStreamingTitles_SSimilarStreamingTitles___kmdW","SHeading":"SimilarStreamingTitles_SHeading__cz3Zx"};